angular.module('flipto.components.common.tasks')
    .config(['$provide', '$compileProvider',
        function ($provide, $compileProvider) {
            $compileProvider.directive('ftStartTask', ['ftTasks', function (ftTasks) {

                return function (scope, elem, attrs) {
                    elem.on('click', function () {
                        scope.$apply(function () {
                            ftTasks.register(attrs.ftStartTask);
                        });
                    });

                    scope.$on('$destroy', function () {
                        elem.unbind('click');
                    });
                };
            }]);
        }
    ]);